<template>
    <div class="ly-note" :class="[isExpand ? 'ly-note__expand' : '']">
        <el-card ref="card">
            <template slot='header'>
            <div>                
                <el-row>
                    <el-col :span="12">
                        银行流水导入
                    </el-col>
                    <el-col :span="12" class="tr">
                        <template v-if="splitArr.length < 1">
                            <el-button size="small" :disabled="text.length < 1" @click="sendEvent('DO_SPLIT')">
                                <i class="fa fa-unlink"></i> 拆分
                            </el-button>
                        </template>
                        <template v-else>
                            <!-- 显示模式的控制 start -->
                            <template  v-if="!isShowTable">
                                <el-switch
                                    v-model="isMirror"
                                    on-text="镜像"
                                    off-text="关闭">
                                </el-switch>&nbsp;
                                <el-button size="small" @click="undoFn">
                                    <i class="fa fa-undo"></i>撤销
                                </el-button>

                                <el-button size="small" @click="toggleView(true)">
                                    <i class="fa fa-eye"></i> 预览
                                </el-button>
                            </template>
                            <template v-else>
                                <el-button size="small" @click="toggleView(false)">
                                    <i class="fa fa-angle-left"></i> 返回
                                </el-button>
                            </template>
                            <!-- 显示模式的控制  end -->
                        </template>
                            <!-- <el-button size="small" @click="toggleSize">
                                <template v-if="isExpand">
                                    <i class="fa fa-compress"></i>&nbsp;最小
                                </template>
                                <template v-else>
                                    <i class="fa fa-expand"></i>&nbsp;最大
                                </template>
                            </el-button> -->
                    </el-col>
                </el-row>
            </div>
            </template>
            <!-- 使用记事本的思路来识别流水 start -->
            <div class="ly-note--body" :style="{height: bodyHeight}"  v-show="!isShowTable">
                <template v-if="splitArr.length < 1">
                    <!-- 开始编辑前的粘贴数据的输入框 start -->
                    <note-textarea v-model="text" @spiltDone="onSpiltDone"></note-textarea>
                    <!-- 开始编辑前的粘贴数据的输入框  end  -->
                </template>

                <template v-else>
                    <!-- 列名的选择列表 start -->
                    <note-select v-model="selectSort"></note-select>
                    <!-- 列名的选择列表 end -->
                    <div class="ly-note--operation f1 flex">
                        <!-- 内容操作区域 start -->
                        <note-operation :is-mirror="isMirror" :arr="splitArr"></note-operation>
                        <!-- 内容操作区域  end  -->
                    </div>
                </template>
            </div>
            <!-- 使用记事本的思路来识别流水  end -->
            <note-table :arr="tableData" v-show="isShowTable"></note-table>
        </el-card>
    </div>
</template>
<script>
    import NoteSelect from './select'
    import RangFn from './rangFn'
    import NoteTextarea from './textarea'
    import NoteOperation from './operation'
    import NoteTable from './table'
    /**
     * 用于银行流水导入的表格功能
     */
    export default {
        name: 'LyNote',
        mixins:[RangFn],
        components: {
            NoteSelect,
            NoteTextarea,
            NoteOperation,
            NoteTable
        },
        data () {
            return {
                text: '', // 银行流水的内容
                isExpand: false,
                selectSort: [], // 按顺序排列的列名
                splitArr: [], // 拆分过后的数据          
                bodyHeight: 'auto',
                viewRadio: 'list', // 视图的单选
                tableData: [], // 表格显示的数据
                isShowTable: false, // 是否显示表格
                isMirror: true // 标识是否开启镜像操作
            }
        },
        methods: {
            /**
             * 窗口大小的切换
             */
            toggleSize () {
                this.isExpand = !this.isExpand
                // 如果是大屏，就计算body的高度
                if (this.isExpand) {
                    this.$nextTick(() => {
                        let cardHeight = this.$refs.card.$el.offsetHeight
                        let headerHeight = this.$refs.card.$children[0].$el.offsetHeight
                        this.bodyHeight = (cardHeight - headerHeight) + 'px'
                    })
                } else { // 否则高度自适应
                    this.bodyHeight = 'auto'
                }
            },
            /**
             * 发送事件的指令
             */
            sendEvent (evtName) {
                this.$eventHub.$emit(evtName)
            },
            /**
             * 数据拆分完成的监听
             */
            onSpiltDone (arr) {
                this.splitArr = arr
            },
            /**
             * 撤销的操作
             */
            undoFn () {
                this.splitArr = []
            },
            /**
             * 切换视图
             */
            toggleView (bool) {
                this.isShowTable = bool
                if (!this.isShowTable) {
                    return
                }
                this.markTableData()
            },
            /**
             * 组装表格的数据
             */
            markTableData () {
                let data = []
                // 根据select 选中的顺序来取得数据
                for (let i = 0, len = this.splitArr.length; i < len; i++) {
                    let row = this.splitArr[i] // 分割后一行的数据
                    let obj = {}
                    for (let j = 0, all = this.selectSort.length; j < all; j++) {
                        obj[this.selectSort[j]['prop']] = this.trim(row[j] || '')
                    }
                    data.push(obj)
                }
                this.tableData = data
            },
            /**
             * 数据的返回
             */
            getData () {
                let data = this.text
                if (this.splitArr.length > 0) {
                    this.markTableData()
                    data = this.tableData
                }
                return data
            }
        }
    }
</script>

<style>
.ly-note .el-card {
    height: 100%;
}
.ly-note .el-card__body {
    padding: 0;
}
/* 编辑器最大化样式 */
.ly-note__expand {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin-top: 0;
    z-index: 999;
}
.ly-note--body{
    position: relative;
    display: flex;
    background: url('../../../assets/img/grid.png');
    overflow: hidden;
}
/* 间隔显示层 */
.ly-note--edge { 
    position: absolute;
    top: 0;
    left: 0;
    width: 24px;
    height: 100%;
    border-right: 1px solid #e8e2d7;
    border-left: 1px solid #e8e2d7;
    background: url('../../../assets/img/edge.png')
}
/* 间隔显示层中的编号 */
.ly-note--edge_no {
    color:#b9a691;
    text-align: center;
    font-size: 12px;
    line-height: 50px;
    opacity: .8;
}
/* 文本操作部分 */
.ly-note--oper {
    position: relative;
    /* padding: 0 0 50px 35px; */
    padding-left: 35px;
    flex: 1;
}
/* 统一的textarea样式 */
.ly-note--textarea {
    display: block;
    min-height: 400px;
    width: 100%;
    color: #635752;
    resize: none;
    background: transparent;
    border: 0;

    font-family: Helvetica,"Microsoft Yahei",ST-Heiti,"Apple Color Emoji";
    font-size: 17px;
    word-wrap: normal;  
    line-height: 50px;
    outline: none;
    padding: 0;
}
.ly-note--textarea::-webkit-scrollbar {
    display: none;
}
</style>